module.exports = __webpack_public_path__ + "static/media/no-img.77f5794e.png";